import { sendRequest } from "../../hooks/requests/useRequest";

export async function getInformationIndicationsPatient ()
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `ExamIndication/List`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}

export async function getInformationIndicationsLaboratory ()
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `ExamLabIndication/List`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}

export async function getByExamPatient (_id_exam)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Exam/ListIndicationsByExam/${_id_exam}`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}

export async function getByExamLaboratory (_id_exam)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Exam/ListLabIndicationsByExam/${_id_exam}`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}


/// Indication Profile

export async function saveAndUpdateProfileIndications(_id_profile, indicationsPatient) {
    const payload = {
        id_profile: _id_profile,
        ListIndications: indicationsPatient.map(id => ({
            id_exam_indication: id
        }))
    };

    const requestOptions = {
        method: "POST",
        body: JSON.stringify(payload)
    };

    const response = await sendRequest(
        requestOptions,
        "Profiles/CreateOrUpdateProfilesIndications"
    );

    return response; 
}


export async function getByProfileList (_id_profile)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Profiles/ListIndicationsByProfile/${_id_profile}`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}

export async function saveAndUpdateProfileIndicationsLab(_id_profile, indicationsLabPatient) {
    const payload = {
        id_profile: _id_profile,
        ListLabIndicationsProfile: indicationsLabPatient.map(id => ({
            id_exam_laboratory_indication: id
        }))
    };

    const requestOptions = {
        method: "POST",
        body: JSON.stringify(payload)
    };

    const response = await sendRequest(
        requestOptions,
        "Profiles/CreateOrUpdateProfileLabIndications"
    );

    return response;
}


export async function getByProfileListLab (_id_profile)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Profiles/ListLabIndicationsByProfile/${_id_profile}`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}

